import { writable } from "svelte/store";
import { api, ApiError } from "../api";
import type { UserSummary } from "../types";

export type AuthStatus = "loading" | "authenticated" | "anonymous";

export const authStatus = writable<AuthStatus>("loading");
export const currentUser = writable<UserSummary | null>(null);

export async function checkSession(): Promise<void> {
  try {
    const { user } = await api.me();
    currentUser.set(user);
    authStatus.set("authenticated");
  } catch {
    currentUser.set(null);
    authStatus.set("anonymous");
  }
}

export async function login(username: string, password: string): Promise<void> {
  const { user } = await api.login(username, password);
  currentUser.set(user);
  authStatus.set("authenticated");
}

export async function logout(): Promise<void> {
  try {
    await api.logout();
  } catch (err) {
    if (!(err instanceof ApiError && err.status === 401)) throw err;
  }
  currentUser.set(null);
  authStatus.set("anonymous");
}
